import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { IIncident } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { IncidentMonitorGateway } from './incident-monitor.gateway';

@Injectable({
  providedIn: 'root',
})
export class IncidentStore {
  private readonly gateway: IncidentMonitorGateway =
    new IncidentMonitorGateway();

  readonly #incidentResource: ResourceRef<
    IApiResponse<IIncident[]> | undefined
  > = resource({
    loader: (): Promise<IApiResponse<IIncident[]>> => {
      return firstValueFrom(this.gateway.get());
    },
  });

  readonly isLoading: Signal<boolean> = computed(() =>
    this.#incidentResource.isLoading()
  );
  readonly incidents: Signal<IIncident[]> = computed((): IIncident[] =>
    this.#incidentResource.hasValue()
      ? (this.#incidentResource.value()?.data ?? [])
      : []
  );
}
